import MvInputTemp from "./MvInput";
import TypographyTemp from "./Typography/Typography";

export const Typography = TypographyTemp;
export const MvInput = MvInputTemp;

export default MvInput;
